
import axiosClient from './axiosClient';

const VISITOR_KEY_PREFIX = 'menu_public_visitor_key_';

const encodeSlug = (slug) => encodeURIComponent(slug);

const getMenuPath = (establishmentSlug, menuSlug) => {
  return `/public/establishments/${encodeSlug(establishmentSlug)}/menus/${encodeSlug(menuSlug)}`;
};

export const getMenuVisitorKey = (
  establishmentSlug,
  menuSlug
) => {
  const storageKey = `${VISITOR_KEY_PREFIX}${encodeSlug(establishmentSlug)}_${encodeSlug(menuSlug)}`;

  const existingKey = localStorage.getItem(storageKey);

  if (existingKey) return existingKey;

  const nextKey =
    window.crypto?.randomUUID?.() ||
    `visitor-${Date.now()}-${Math.random().toString(16).slice(2)}`;

  localStorage.setItem(storageKey, nextKey);

  return nextKey;
};

export const publicMenuApi = {
  // Get public menu
  getMenu(establishmentSlug, menuSlug) {
    return axiosClient.get(
      getMenuPath(establishmentSlug, menuSlug)
    );
  },

  // Track visits and interactions
  track(establishmentSlug, menuSlug, payload = {}) {
    return axiosClient.post(
      `${getMenuPath(establishmentSlug, menuSlug)}/track`,
      {
        ...payload,
        visitor_key:
          payload.visitor_key ||
          getMenuVisitorKey(establishmentSlug, menuSlug),
      }
    );
  },

  // Toggle product like
  toggleLike(establishmentSlug, menuSlug, productId) {
    return axiosClient.post(
      `/public/products/${productId}/like`,
      {
        visitor_key: getMenuVisitorKey(
          establishmentSlug,
          menuSlug
        ),
      }
    );
  },

  // Submit product review
  createReview(productId, payload = {}) {
    return axiosClient.post(
      `/public/products/${productId}/reviews`,
      payload
    );
  },

  // Place customer order
  createOrder(establishmentSlug, menuSlug, payload = {}) {
    return axiosClient.post(
      `${getMenuPath(establishmentSlug, menuSlug)}/orders`,
      {
        ...payload,
        visitor_key:
          payload.visitor_key ||
          getMenuVisitorKey(establishmentSlug, menuSlug),
      }
    );
  },

  // Get customer's orders
  getCustomerOrders(establishmentSlug, menuSlug, params = {}) {
    return axiosClient.get(
      `${getMenuPath(establishmentSlug, menuSlug)}/orders`,
      {
        params: {
          ...params,
          visitor_key:
            params.visitor_key ||
            getMenuVisitorKey(establishmentSlug, menuSlug),
        },
      }
    );
  },

  // Get a specific customer order
  getCustomerOrder(
    establishmentSlug,
    menuSlug,
    orderId,
    params = {}
  ) {
    return axiosClient.get(
      `${getMenuPath(establishmentSlug, menuSlug)}/orders/${encodeURIComponent(orderId)}`,
      {
        params: {
          ...params,
          visitor_key:
            params.visitor_key ||
            getMenuVisitorKey(establishmentSlug, menuSlug),
        },
      }
    );
  },
};

export default publicMenuApi;
